export function isValidStringOfAvantLongId(id: string): boolean {
    try {
        const isValidAvantLongId = /^[0-9]+$/.test(id)
        const maxSafeLengthOfKotlinLong = id.length <= 19
        return isValidAvantLongId && maxSafeLengthOfKotlinLong
    } catch {
        return false
    }
}